import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../Variables';

const LoaderBox = styled.div`
  position: relative;
  left: 0;
  top: 0px;
  width: 100%;
  height: 2px;
  animation: load 3s linear both;
  background-color: ${COLORS.darkGrey};
  @keyframes load {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
      background-color: ${COLORS.greyColor};
    }
  }
`;

const Loader = () => {
  return <LoaderBox id="loader" />;
};

export default Loader;
